import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TILES = [
  { to: "/admin/communications", title: "Communications", desc: "Email + WhatsApp activity overview", icon: "📨" },
  { to: "/admin/email-inbox", title: "Email inbox", desc: "Manage candidate email threads", icon: "📧" },
  { to: "/admin/email-settings", title: "Email settings", desc: "Sender identity & SMTP config", icon: "⚙" },
  { to: "/admin/whatsapp-inbox", title: "WhatsApp inbox", desc: "Conversation history with candidates", icon: "💬" },
  { to: "/admin/whatsapp-settings", title: "WhatsApp settings", desc: "Twilio / WABA config", icon: "🟢" },
  { to: "/admin/email-templates", title: "Email templates", desc: "Reusable invite & reminder templates", icon: "🖋" },
  { to: "/admin/scheduling", title: "Scheduling", desc: "Interviewer calendars & defaults", icon: "🗓" },
  { to: "/admin/settings/candidate-experience", title: "Candidate experience", desc: "What candidates see after scoring (AI feedback toggle)", icon: "💬" },
  { to: "/admin/role", title: "Roles & permissions", desc: "Who can do what", icon: "🛡" },
  { to: "/admin/integrations", title: "Integrations", desc: "Connect your ATS — Greenhouse, Lever, Ashby, and more", icon: "🔌" },
  { to: "/admin/audit", title: "Audit log", desc: "All admin activity", icon: "📜" },
];

export default function Settings() {
  const nav = useNavigate();
  useEffect(() => { document.title = "Settings - Ample Hire"; }, []);
  return (
    <div className="page-enter">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-vf-base">Settings</h1>
          <p className="text-sm text-vf-muted mt-1">Configure your Ample Hire workspace</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {TILES.map((t) => (
          <button
            key={t.to}
            onClick={() => nav(t.to)}
            className="text-left bg-white border border-slate-200 rounded-xl p-5 hover:border-vf-highlight hover:shadow-sm transition-all"
          >
            <div className="text-2xl mb-2">{t.icon}</div>
            <div className="text-sm font-semibold text-vf-base">{t.title}</div>
            <div className="text-xs text-vf-muted mt-1">{t.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
